import { showErrorNotification } from '../global/notifications';
import {gridExport} from './all';

const createLessonsLearnedGrid = function () {
    let $lessonsGrid = $('#lessonsLearnedGrid');

    if ($lessonsGrid.length) {
        let dateTime = new Date(),
            fileName = 'LessonsLearnedExport_' + dateTime.getFullYear() + (dateTime.getMonth() + 1) + dateTime.getDate() + '.xlsx',
            pid = $('#pid').val(),
            lessonAttGrid = function (e) {
                $('<div class="LessonAttGrid"/>').appendTo(e.detailCell).kendoGrid({
                    columns: [
                        {
                            field: 'fName', title: 'File Name'
                        }, {
                            field: '', title: ''
                        }
                    ],
                    dataSource: {
                        autoSync: true, schema: {
                            model: {
                                id: 'attId', fields: {
                                    attId: {editable: false, hidden: true},
                                    fName: {editable: false},
                                    fExt: {editable: false}
                                }
                            }
                        }, transport: {
                            read: {
                                url: '/Forms/ProjectReview/GetLessonDocuments',
                                type: 'POST',
                                dataType: 'json',
                                contentType: 'application/json'
                            }, parameterMap: function (data, type) {
                                if (type === 'read') {
                                    let params = {};
                                    params['id'] = e.data.lid;
                                    return kendo.stringify(params);
                                }
                            }
                        }, change: initButtons, requestEnd: function (e) {
                            let $attachmentGrid = $('.LessonAttGrid');
                            $attachmentGrid.data('kendoGrid').refresh();
                            $attachmentGrid.ready(function () {
                                deleteAttachments();
                            });
                        }
                    },
                    rowTemplate: kendo.template($('#lessonFilesTemplate').html()),
                    editable: false,
                    scrollable: true,
                    autoBind: true
                });
            },
            initButtons = function (e) {
                let $buttonsToMake = $('#lessonFileDownload');
                $buttonsToMake.kendoButton({
                    icon: 'download', click: function (e) {
                        let attId = e.target.getAttribute('data-attId');
                        return false;
                    }
                });
            };

        $lessonsGrid.kendoGrid({
            columns: [
                {
                    field: 'issueNo', title: 'Issue No.', type: 'number', width: 55, height: 80
                }, {
                    field: 'lessonLearned', title: 'Lesson Learned / Best Practice', width: 125
                }, {
                    field: 'rootCause', title: 'Root Causes / Supporting Conditions', width: 125
                }, {
                    field: 'areaImpact', title: 'Area of Impact', width: 80
                }, {
                    field: 'recAction', title: 'Recommended Actions / Follow Up', width: 125
                }, {
                    field: 'dept', title: 'Department', width: 100
                }, {
                    field: 'lid', hidden: true, menu: false
                }, {
                    field: 'attachmentIds', hidden: true, menu: false
                }
            ], dataSource: {
                autoSync: false, schema: {
                    model: {
                        id: 'lid', fields: {
                            lid: {editable: false, hidden: true, nullable: true},
                            attachmentIds: {editable: false},
                            issueNo: {editable: false, nullable: true},
                            lessonLearned: {editable: false},
                            rootCause: {editable: false},
                            areaImpact: {editable: false},
                            recAction: {editable: false},
                            supFiles: {editable: false},
                            dept: {editable: false}
                        }
                    }
                }, transport: {
                    read: {
                        // url: '@Url.Action('GetLessonsLearned', new {pid = Model.Project.Pid})', type: 'GET', dataType: 'json'
                        url: '/Forms/ProjectReview/GetLessonsLearned?pid=' + pid, type: 'GET', dataType: 'json'
                    }, create: {
                        // url: '@Url.Action('CreateLessonLearned', new {pid = Model.Project.Pid})', type: 'POST', contentType: 'application/json', dataType: 'json'
                        url: '/Forms/ProjectReview/CreateLessonLearned?pid=' + pid,
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json'
                    }, parameterMap: function (data, type) {
                        if (type === 'create') {
                            return kendo.stringify(data);
                        }
                    }
                }, requestEnd: function (e) {
                    if (e.type !== 'read') {
                        $lessonsGrid.data('kendoGrid').dataSource.read();
                    }
                    $lessonsGrid.data('kendoGrid').refresh();
                }
            },
            dataBound: function (e) {
                let dataPoints = $lessonsGrid.data('kendoGrid').dataSource._data.length;
                if (dataPoints !== 0) {
                    $('.js-lessons-learned-tag').text(`${dataPoints} Lesson${dataPoints === 1 ? '' : 's'} Learned`);
                }
            },
            detailInit: lessonAttGrid, toolbar: $('#lessonsLearnedTemplate').html(), excel: {
                fileName: fileName, filterable: true
            }, scrollable: true, sortable: {
                mode: 'multiple'
            }, filterable: true, editable: false, mobile: true, columnMenu: true
        });

        $('#addNewBtn').kendoButton({
            icon: 'plus'
        }).click(function () {
            addNewLessonDialog();
        });

        //Add Grid Export Functionality
        gridExport();
    }
};

const addNewLessonDialog = function() {
    const $creationPopup = $('#newLessonPopup');

    if ($creationPopup.length) {
        const pid = $('#pid').val();

        $creationPopup.kendoDialog({
            title: 'New Lesson',
            closable: true,
            modal: {
                preventScroll: true,
            },
            width: 'auto',
            height: 'auto',
            maxHeight: '500px',
            content: $('#newLessonForm').html(),
            actions: [
                {
                    text: 'Create Lesson',
                    action: function addLessonToGrid(event) {
                        const $lessonData = $('#newLessonPopup').find('.newLessonData');
                        const lesson = {};
                        $.each($lessonData, function(index, value) {
                            lesson[$lessonData[index].id] = $lessonData[index].value;
                        });

                        let k_lessonsGrid = $('#lessonsLearnedGrid').data('kendoGrid');
                        k_lessonsGrid.dataSource.add(lesson);
                        k_lessonsGrid.dataSource.sync();

                        return true;
                    },
                    primary: true,
                },
                {
                    text: 'Cancel',
                },
            ],
            buttonLayout: 'normal',
        });

        $creationPopup.find('#supFiles').kendoUpload({
            showFileList: true,
            multiple: true,
            async: {
                saveUrl: '/Forms/ProjectReview/LessonLearnedQueueDocument?pid=' + pid,
            },
            upload: function(e) {
                const xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener('readystatechange', function(e) {
                        if (xhr.readyState === 1 /* OPENED */) {
                            xhr.setRequestHeader('projectId', $('#prPIDHidden').val());
                        }
                    });
                }
            },
            success: function(response) {
                if (response?.response?.Error) {
                    showErrorNotification(response.response.Error);
                    throw new Error(response.response.Error);
                }

                const $attachmentIds = $('#newLessonPopup').find('#AttachmentIds'),
                    prevVal = $attachmentIds.val();
                $attachmentIds.val(prevVal + response.response.AttachmentIds);
                return true;
            },
            error: function(e) {
                console.error(e);
            },
            dropZone: '.dropZoneElement',
        });

        //Open Dialog Window
        $creationPopup.data('kendoDialog').open();
    }
};

const deleteAttachments = function () {
    let $deleteAttachment = $('.lessonFileDelete');

    if ($deleteAttachment.length) {
        $deleteAttachment.click(function () {
            let attId = this.getAttribute('data-attId'), $thisGrid = $('#lessonsLearnedGrid');
            $.post('/Forms/ProjectReview/RemoveAttachment?attId=' + attId, function () {
                if ($thisGrid.length) {
                    let k_thisGrid = $thisGrid.data('kendoGrid');
                    if (k_thisGrid) {
                        k_thisGrid.refresh();
                    }
                }
            });
        });
    }
};

export default function () {
    createLessonsLearnedGrid();
}